import { inject, Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { AdminProductQuantityHistoryReasonTypeProviderService } from '../providers/admin-product-quantity-history-reason-type-provider.service';
import { AdminProductQuantityHistoryReasonType } from '../enums/admin-product-quantity-history-reason-type';

@Pipe({
  name: 'adminProductQuantityHistoryReasonType',
})
export class AdminProductQuantityHistoryReasonTypePipe implements PipeTransform {
  private readonly provider = inject(
    AdminProductQuantityHistoryReasonTypeProviderService,
  );

  public transform(
    type: AdminProductQuantityHistoryReasonType,
  ): Observable<string> {
    return this.provider.labelFor(type);
  }
}
